<script>
import BaseChessboard from "@/components/variants/BaseChessboard";

export default {
  name: "PvPChessboard",

  extends: BaseChessboard,

  methods: {},
};
</script>
